import React, { useState } from "react";
import MedicalPhotoLightbox from "./MedicalPhotoLightbox";

const kindLabel = (k) => (k || "").replace(/_/g, " ");

/**
 * Grid of medical-record attachment thumbnails.
 *
 * • Renders nothing when `attachments` is empty (auto-hide per spec).
 * • Uses native `loading="lazy"` on every <img> so a client with a
 *   long history doesn't pay for photos that aren't on screen yet.
 * • Tapping a thumbnail opens the shared `MedicalPhotoLightbox` at
 *   the correct index — swipeable across all photos of the visit.
 */
export default function AttachmentThumbnails({ attachments, testidPrefix = "attachment", size = "md" }) {
  const [lightboxIdx, setLightboxIdx] = useState(null);
  const list = Array.isArray(attachments) ? attachments.filter((a) => a && a.data_url) : [];
  if (list.length === 0) return null;

  const heightClass = size === "sm" ? "h-16" : "h-20";

  return (
    <>
      <div
        className="mt-2 grid grid-cols-3 gap-2"
        data-testid={testidPrefix}
      >
        {list.map((att, i) => (
          <button
            type="button"
            key={att.id || `${att.kind}-${i}`}
            onClick={() => setLightboxIdx(i)}
            className="block rounded-lg overflow-hidden border border-border bg-white text-left group focus:outline-none focus:ring-2 focus:ring-primary"
            data-testid={`${testidPrefix}-thumb-${i}`}
            aria-label={`Preview ${kindLabel(att.kind) || "photo"}`}
          >
            <img
              src={att.data_url}
              alt={kindLabel(att.kind) || "Medical attachment"}
              loading="lazy"
              decoding="async"
              className={`w-full ${heightClass} object-cover group-hover:brightness-110 transition`}
            />
            <div className="text-[10px] text-center py-1 text-muted-foreground capitalize truncate px-1">
              {kindLabel(att.kind) || "photo"}
            </div>
          </button>
        ))}
      </div>
      <MedicalPhotoLightbox
        open={lightboxIdx !== null}
        onClose={() => setLightboxIdx(null)}
        photos={list}
        startIndex={lightboxIdx ?? 0}
      />
    </>
  );
}
